import React from "react";
import DatePicker from "../FormComponents/DatePicker";
import CheckBoxComponent from "../FormComponents/CheckBox";
import { getIn } from "formik";
import { TextField, FormControlLabel, FormGroup, Checkbox, FormHelperText } from "@material-ui/core";
import { Number } from "../../utils/Number";
import { TextMaskCustom } from "../../utils/TextMaskCustom";
import AutoCompleteStates from "../FormComponents/AutoCompleteStates";
import { SsnMaskCustom } from "../../utils/SsnMaskCustom";
var _ = require("lodash");

const patientInfoData = [
  {
    label: "First Name",
    name: "patient.patientFirstName",
    type: "text",
    required: true,
    disabled: true,
  },
  {
    label: "Middle Name",
    name: "patient.patientMiddleName",
    type: "text",
    disabled: true,
  },
  {
    label: "Last Name",
    name: "patient.patientLastName",
    type: "text",
    required: true,
    disabled: true,
  },
  { label: "Social Security Number", name: "patient.ssn", type: "ssn" },
  { label: "Reference Number", name: "patient.facsNumber", type: "text" },
  {
    label: "Date of Birth",
    name: "patient.dateOfBirth",
    type: "datePicker",
    required: true,
    disableFuture: true,
  },

  {
    label: "Address",
    name: "patient.addressLine1",
    type: "text",
    required: true,
  },
  { label: "City", name: "patient.city", type: "text", required: true },
  {
    label: "State",
    name: "patient.state",
    type: "autoComplete",
    required: true,
  },
  { label: "ZIP Code", name: "patient.zip", type: "number", required: true },
  { label: "Phone", name: "patient.landPhone", type: "phone", required: true, disabled: true },
  { label: "Email", name: "patient.email", type: "text", required: true, disabled: true },

  {
    label: "Date of Accident",
    name: "patient.accidentDate",
    type: "datePicker",
    required: true,
    disableFuture: true,
  },
  {
    label: "Healthcare Provider",
    name: "patient.healthCareProvider",
    type: "text",
  },
  {
    label: "Date of Service",
    name: "patient.serviceDate",
    type: "datePicker",
    disableFuture: true,
  },
];

const PatientInfo = ({ values, touched, error, handleChange, errors, setFieldValue }) => {
  const setAnother = (e) => {
    let type = _.cloneDeep(values.accident.accidentType) || [];
    let type2 = _.cloneDeep(values.autoAccident.accidentType) || [];
    let type3 = _.cloneDeep(values.employer.accidentType) || [];
    let type4 = _.cloneDeep(values.autoInsurance.accidentType) || [];

    type.includes(e.target.value)
      ? values.accident.accidentType.splice(type.indexOf(e.target.value), 1)
      : setFieldValue("accident.accidentType", [...type, e.target.value]);

    type2.includes(e.target.value)
      ? values.autoAccident.accidentType.splice(type2.indexOf(e.target.value), 1)
      : setFieldValue("autoAccident.accidentType", [...type2, e.target.value]);

    type3.includes(e.target.value)
      ? values.employer.accidentType.splice(type3.indexOf(e.target.value), 1)
      : setFieldValue("employer.accidentType", [...type3, e.target.value]);

    type4.includes(e.target.value)
      ? values.autoInsurance.accidentType.splice(type4.indexOf(e.target.value), 1)
      : setFieldValue("autoInsurance.accidentType", [...type4, e.target.value]);
  };
  return (
    <div className="card custom-card">
      {/* ===== Type of Accident ==== */}
      <div className="accident-type">
        <div className="required-line">All fields marked with "*" are required</div>
        <div className="row align-items-top">
          <div className="col-md-12 col-xl-2 col-lg-3 title pr-1">
            <p>
              Type of Accident{" "}
              {getIn(touched, "patient.accidentType") &&
              getIn(errors, "patient.accidentType") &&
              values.patient.accidentType.length === 0 ? (
                <span style={{ color: "#f44336" }}>*</span>
              ) : (
                "*"
              )}
            </p>
          </div>
          <div className="form-group col-md-12 col-xl-10 col-lg-9 patient-info">
            <CheckBoxComponent
              name="patient.accidentType"
              checkBoxType="multi"
              value={values.patient.accidentType}
              label={["Auto", "Slip and Fall", "Work Related", "Crime Related", "Dog Bite", "Other"]}
              handleChange={(e) => {
                handleChange(e);
                setAnother(e);
              }}
              error={Boolean(
                getIn(touched, "patient.accidentType") && getIn(errors, "patient.accidentType")
              )}
              helperText={
                getIn(touched, "patient.accidentType") &&
                getIn(errors, "patient.accidentType") &&
                getIn(errors, "patient.accidentType")
              }
            />
            {values.patient &&
            values.patient.accidentType &&
            values.patient.accidentType.includes("Other") ? (
              <div>
                <TextField
                  // label={other}
                  name={"patient.otherAccidentReason"}
                  onChange={handleChange}
                  value={values.patient.otherAccidentReason}
                  placeholder="Other Reason"
                  aria-label="text-field"
                  fullWidth
                  error={Boolean(
                    getIn(touched, "patient.otherAccidentReason") &&
                      getIn(errors, "patient.otherAccidentReason")
                  )}
                  helperText={
                    getIn(touched, "patient.otherAccidentReason") &&
                    getIn(errors, "patient.otherAccidentReason") &&
                    getIn(errors, "patient.otherAccidentReason")
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{ maxLength: 50 }}
                />
              </div>
            ) : null}
            <FormHelperText>
              {getIn(touched, "patient.accidentType") &&
                getIn(errors, "patient.accidentType") &&
                values.patient.accidentType.length === 0 && (
                  <div style={{ color: "#f44336", fontSize: "13px", marginTop: "-18px" }}>
                    Please select at least one type
                  </div>
                )}
            </FormHelperText>
          </div>
        </div>
      </div>

      {/* ===== Patinet Info ==== */}
      <div className="patinet-info">
        <div className="title">
          <h5>PATIENT INFORMATION</h5>
        </div>
        <div className="row text-center ">
          {patientInfoData.map(({ label, name, type, required = false, disableFuture = false, disabled = false }, ind) => {
            let obj = {
              a: `${name}`.split(".")[0],
              b: `${name}`.split(".")[1],
            };
            if (type === "datePicker") {
              return (
                <div className="form-group col-md-6 col-lg-4" key={name + ind}>
                  <DatePicker
                    name={name}
                    autoOk
                    label={label}
                    format="DD/MM/yyyy"
                    value={values[obj.a][obj.b]}
                    required={required}
                    onChange={(val) => {
                      setFieldValue(name, val);
                    }}
                    error={Boolean(getIn(touched, name) && getIn(errors, name))}
                    helperText={getIn(touched, name) && getIn(errors, name) && getIn(errors, name)}
                    disableFuture={disableFuture}
                  />
                </div>
              );
            } else if (type === "text") {
              return (
                <div className="form-group col-md-6 col-lg-4" key={name + ind}>
                  <TextField
                    label={label}
                    name={name}
                    onChange={handleChange}
                    value={values[obj.a][obj.b]}
                    aria-label="text-field"
                    fullWidth
                    error={Boolean(getIn(touched, name) && getIn(errors, name))}
                    helperText={getIn(touched, name) && getIn(errors, name) && getIn(errors, name)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required={required}
                    inputProps={{
                      maxLength:
                        name === "patient.addressLine1" || name === "patient.healthCareProvider"
                          ? 50
                          : 35,
                    }}
                    disabled={disabled}
                  ></TextField>
                </div>
              );
            } else if (type === "number" || type === "phone" || type === "ssn") {
              return (
                <div className="form-group col-md-6 col-lg-4" key={name + ind}>
                  <TextField
                    label={label}
                    name={name}
                    onChange={handleChange}
                    value={values[obj.a][obj.b]}
                    aria-label="text-field"
                    fullWidth
                    error={Boolean(getIn(touched, name) && getIn(errors, name)) }
                    helperText={getIn(touched, name) && getIn(errors, name) && getIn(errors, name)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{ maxLength: type === "number" ? 5 : undefined }}
                    InputProps={{
                      inputComponent:
                        type === "phone" ? TextMaskCustom : type === "ssn" ? SsnMaskCustom : Number,
                    }}
                    required={required}
                    disabled={disabled}
                  ></TextField>
                </div>
              );
            } else if (type === "checkBox") {
              return (
                <div className="form-group col-md-12 col-lg-6" key={name + ind}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={values[obj.a][obj.b]}
                          onChange={handleChange}
                          name={name}
                          color="primary"
                        />
                      }
                      label={label}
                    />
                  </FormGroup>
                </div>
              );
            } else if (type === "autoComplete") {
              return (
                <div className="form-group col-md-6 col-lg-4" key={name + ind}>
                  <AutoCompleteStates
                    label={label}
                    name={name}
                    onChange={(e, value) => {
                      if (value) {
                        setFieldValue(`${name}`, value.code);
                      } else {
                        setFieldValue(`${name}`, "");
                      }
                    }}
                    value={values[name]}
                    aria-label="auto-complete"
                    fullWidth
                    error={Boolean(getIn(touched, name) && getIn(errors, name))}
                    helperText={getIn(touched, name) && getIn(errors, name) && getIn(errors, name)}
                    required={required}
                  />
                </div>
              );
            }
          })}

          <div className="form-group col-md-12 col-lg-6 address-line">
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={values.patient.emailConsent}
                    onChange={handleChange}
                    name={"patient.emailConsent"}
                    style={{ color: "#0166A4" }}
                  />
                }
                label="Authorize us to contact you by email?"
              />
            </FormGroup>
          </div>
          <div className="form-group col-md-12 col-lg-6">
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={values.patient.cellPhoneConsent}
                    onChange={handleChange}
                    name={"patient.cellPhoneConsent"}
                    style={{ color: "#0166A4" }}
                  />
                }
                label="Authorize us to contact you by cell phone?"
              />
            </FormGroup>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(PatientInfo);
